import { SIZE_MAPPING_OPTION } from "../../../../../../applications/constants/AppConst";
import { currencyFormat } from "../../../../../../applications/utils/NumberUtils";
import { CreateOrderRequest } from "../../../../../../infrastructure/model/OrderModel";
import { ToppingModel } from "../../../../../../infrastructure/model/ProductItemModel";
import "./OrderSummaryModal.scss";

interface Props {
  values: CreateOrderRequest;
  toppingData: ToppingModel[];
}

function OrderSummaryModal(props: Props) {
  const { values, toppingData = [] } = props;
  return (
    <div className="order-summary">
      {/* Header */}
      <div className="order-summary__header">
        <div className="icon">🎉</div>
        <div className="subtitle">Cảm ơn quý khách đã tin tưởng 🙏</div>
      </div>

      {/* Customer Info */}
      <div className="order-summary__card">
        <div className="card-title">👤 Thông tin nhận hàng</div>

        <div className="info-row">
          <span>Họ tên:</span>
          <b>{values.username}</b>
        </div>

        <div className="info-row">
          <span>SĐT:</span>
          <b className="highlight">{values.user_phone}</b>
        </div>

        <div className="info-row">
          <span>Địa chỉ:</span>
          <b>{values.address}</b>
        </div>
      </div>

      {/* Items */}
      <div className="order-summary__card">
        <div className="card-title">🧾 Chi tiết đơn hàng</div>

        <div className="item-list">
          {values.items.map((item, index) => (
            <div key={index} className="item">
              <div className="item-left">
                <div className="item-name">{item.item_name}</div>
                <div className="item-meta">
                  {/* Size */}
                  <div className="size">
                    🧋 Size:{" "}
                    {SIZE_MAPPING_OPTION?.find((s) => s.value === item.item_size)?.label ?? ""}
                  </div>

                  {/* Note */}
                  {item.item_note && <div className="note">📝 {item.item_note}</div>}

                  {/* Toppings */}
                  {item?.topping_ids?.length && (
                    <div className="toppings">
                      {item.topping_ids.map((tId, index) => (
                        <span key={index} className="topping-tag">
                          + {toppingData?.find((t) => t.id === tId)?.name}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="item-right">x{item.item_quantity}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Total */}
      <div className="order-summary__total">
        <span>💰 Tổng thanh toán</span>
        <span className="price">{currencyFormat(values.discount_price ?? 0)}</span>
      </div>

      {/* Note */}
      <div className="order-summary__note">
        Vui lòng giữ điện thoại để nhân viên liên hệ xác nhận đơn 📞
      </div>
    </div>
  );
}
export default OrderSummaryModal;
